import { render } from "./TotalItem.vue?vue&type=template&id=6241ae3e&ts=true"
import script from "./TotalItem.vue?vue&type=script&lang=ts"
export * from "./TotalItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__